// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectClosePositionMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_CLOSEPOSITION);
        this.OrderWasManual = false;
        this.Id = null;
        this.CloseOrderId = null;
        this.ClosePrice = 0;
        this.CloseTime = null;
        this.Symbol = '';
        // для BT
        this.Pnl = 0;
        this.Commission = 0;
    }
}
